const API_URL = "https://tracker.freshmart.pe";

export async function getTrackerHistory({
    token,
    page = 1,
    limit = 20,
    signal,
}) {
    if (!token) {
        throw new Error("El token es obligatorio");
    }

    const params = new URLSearchParams({
        token,
        page: String(page),
        limit: String(limit),
    });

    const response = await fetch(
        `${API_URL}/api/dashboard/tracker-history?${params.toString()}`,
        {
            method: "GET",
            headers: {
                Accept: "application/json",
            },
            signal,
        }
    );

    const result = await response.json();

    if (!response.ok || !result.success) {
        throw new Error(
            result.message ?? "No se pudo obtener el historial"
        );
    }

    return result;
}